const PHONE_REGEX = /(\d{2})(\d{4,5})(\d{4})/;

export function formatPhone(phone: string) {
  return phone.replace(PHONE_REGEX, "($1) $2-$3");
}
